import { inIFrame } from '@thoughtspot/browser-util';
import { getNonce } from '@thoughtspot/codec-util';
import { getQueryParamsAndQueryString } from '@thoughtspot/env-flags';
import { versionCompare } from '@thoughtspot/js-util';
import { create } from '@thoughtspot/logger';
import { isMobileWebViewMessagingEnabled, sdkVersion } from '.';
const logger = create('embedBaseUtil');
const isWebView = () => {
    if (isMobileWebViewMessagingEnabled()) {
        return typeof window.ReactNativeWebView !== 'undefined';
    }
    return false;
};
const isEmbeddedApp = () => {
    return (inIFrame() ||
        window.location.href.indexOf('/embed/') > -1 ||
        isWebView());
};
function isAppInIFrame() {
    return inIFrame();
}
const cacheFunctionOnly = (fn) => {
    const cache = new Map();
    return (...args) => {
        if (!cache.has(fn)) {
            cache.set(fn, fn(...args));
        }
        return cache.get(fn);
    };
};
const getQueryParams = (qParams) => {
    const queryParams = {};
    Object.keys(qParams).forEach(key => {
        if (qParams[key].length === 1) {
            const value = qParams[key][0];
            let decodedValue;
            try {
                decodedValue = decodeURIComponent(value);
            }
            catch (e) {
                decodedValue = value;
                logger.warn('[getQueryParams] Failed to decode metadata:', e);
            }
            try {
                if (/^(\d+|\d+\.\d+)$/.test(decodedValue))
                    queryParams[key] = decodedValue;
                else
                    queryParams[key] = JSON.parse(decodedValue);
            }
            catch (e) {
                queryParams[key] = decodedValue;
                logger.warn('[getQueryParams] Failed to parse metadata:', e);
            }
        }
        else {
            queryParams[key] = qParams[key];
        }
    });
    return queryParams;
};
const URI_ENCODED_EMBED_PARAM_KEYS = [
    'searchTokenString',
    'hostAppUrl',
];
const decodeEmbedParams = (params) => {
    const decodedParams = { ...params };
    URI_ENCODED_EMBED_PARAM_KEYS.forEach(key => {
        const value = decodedParams[key];
        if (typeof value !== 'string') {
            return;
        }
        try {
            decodedParams[key] = decodeURIComponent(value);
        }
        catch (e) {
            logger.warn(`[decodeEmbedParams] Failed to decode ${key}:`, e);
        }
    });
    return decodedParams;
};
const _getEmbedQueryParams = () => {
    return getQueryParams(getQueryParamsAndQueryString().queryParamsMultiValue);
};
const getEmbedQueryParams = cacheFunctionOnly(_getEmbedQueryParams);
const versionToBeSkipped = () => {
    return versionCompare(sdkVersion(), '1.17.0') >= 0;
};
let customVariablesForThirdPartyTools = {};
const setCustomVariablesForThirdPartyToolsFromAppInit = (data) => {
    customVariablesForThirdPartyTools = data;
};
const setcustomVariablesForThirdPartyTools = (Logger) => {
    const data = customVariablesForThirdPartyTools;
    const isCustomVariablesObjectEmpty = Object.keys(data).length === 0;
    window.tsEmbed = null;
    if (!isCustomVariablesObjectEmpty)
        window.tsEmbed = data;
    Logger.info('CustomVariablesForEmbedCustomVariables are successfully set from EmbedInit');
};
const injectEmbedCustomerGuideScript = async (Logger, embedCustomerGuideSrc) => {
    const scriptTag = document.createElement('script');
    scriptTag.src = embedCustomerGuideSrc;
    scriptTag.async = true;
    scriptTag.id = 'embed-customer-guide-script';
    scriptTag.setAttribute('nonce', getNonce());
    scriptTag.onload = () => {
        Logger.info(`Script loaded successfully from ${embedCustomerGuideSrc}`);
    };
    scriptTag.onerror = error => {
        Logger.warn(`Failed to load the script from ${embedCustomerGuideSrc}`);
    };
    const firstScriptNode = document.getElementsByTagName('script')[0];
    const toInsertAt = firstScriptNode.parentNode || document.body;
    toInsertAt.insertBefore(scriptTag, firstScriptNode);
};
export { isWebView, isEmbeddedApp, isAppInIFrame, _getEmbedQueryParams, getQueryParams, decodeEmbedParams, URI_ENCODED_EMBED_PARAM_KEYS, cacheFunctionOnly, injectEmbedCustomerGuideScript, setCustomVariablesForThirdPartyToolsFromAppInit, setcustomVariablesForThirdPartyTools, versionToBeSkipped, getEmbedQueryParams, };
//# sourceMappingURL=embed-base-util.js.map